import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AGREEMENT_HTML } from '../../config';

import { CommonService } from '../../services/common.service';
import { GetinfoService } from '../../services/getinfo.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './agreement.component.html'
})
export class AgreementComponent implements OnInit {

  agreetext:string = AGREEMENT_HTML;
  policytext:string = AGREEMENT_HTML;

  agree1:boolean = false;
  agree2:boolean = false;
  myinfo: any;

  constructor(
    private router: Router,
    public commonService: CommonService,
    public getinfoService: GetinfoService
  ) { }

  ngOnInit(): void {
    let myinfo = localStorage.getItem('myinfo');

    if(myinfo != '' && myinfo != 'undefined' && myinfo !== undefined && myinfo !== null) {
      this.myinfo = JSON.parse(myinfo);
      this.getinfoService.refreshToken(this.myinfo.mem_id);
    }
  }

  agreeproc() {
    if(this.agree1 && this.agree2) {
      this.getinfoService.sendDataPost("/agreeproc",{}).then((data) => {
        let res: any = data;
        if(res.code == 'success') {

          // 동의사항 저장
          let myinfo = localStorage.getItem('myinfo');
          if(myinfo != '' && myinfo != 'undefined' && myinfo !== undefined && myinfo !== null) {
            let myinfoArr = JSON.parse(myinfo);
            myinfoArr.agree = "1";
            localStorage.setItem('myinfo',JSON.stringify(myinfoArr));
          }

          this.commonService.confirm({
            content:'<b>반갑습니다</b><br><br>SD 네트웍스 파트너시스템을 시작합니다.<br>사용가이드를 참조해주시고, 궁금한 점은 언제든 아래 번호로 연락주시면 자세히 안내하겠습니다.<br><br><b>문의 : 070-4480-9337</b><br><br><small>*중요한 추가 안내를 위해 파트너시스템 담당자가 위의 발신번호로 수일 내에 연락을 드립니다.</small>',
            cancelTitle: '사용자가이드 보기',
            confirmTitle: '홈으로'
          }).then((ok:any) => {
            if(ok) {
              this.router.navigateByUrl("/");
            }
            else {
              this.router.navigateByUrl("/etc/guide");
            }
          });
        }
      });
    }

  }
}
